import { render } from "./EposAppRoot.vue?vue&type=template&id=3980db69"
import script from "./EposAppRoot.vue?vue&type=script&lang=js"
export * from "./EposAppRoot.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__